import axios from "../http";
let module = "/sysRole";

function saveRolePermission(data){
  return axios.put(module + '/rolePermission',data);
}

function addRole(data){
	return axios.post(module,data);
}

function updateRole(data){
	return axios.put(module,data);
}

function deleteRole(id){
	return axios.delete(module + '/' + id);
}

function getRoleById(id){
	return axios.get(module + '/' + id);
}

export default {
  saveRolePermission,
  addRole,
  updateRole,
  deleteRole,
  getRoleById
}
